
const STATE = {
    ACTIVE: 'ACTIVE',INACTIVE: 'INACTIVE', PENDING: 'PENDING', CANCEL: 'CANCEL', NULL: null
};

class PlanLimitsUsersController {
    [x: string]: any;
 	 static $inject = ['TransferData','AuthService','AccountsService'];
    constructor(TransferData, AuthService, AccountsService) {
        this.TransferData = TransferData;
        this.UsersIdsToChange = [];
        this.AuthService = AuthService;
        this.AccountsService = AccountsService;
        this.title = this.TransferData.getArguments('title');
        this.description = this.TransferData.getArguments('description');
        this.usersList = this.TransferData.getArguments('list');
        this.maxLimitUsersPlan = this.TransferData.getArguments('limit');
        this.defer = this.TransferData.getArguments('defer');
        this.currentUser = this.AuthService.currentUser();
    }

    $onInit () {

    }

    success() {
        this.defer.resolve(this.UsersIdsToChange)
    }

    getName(user) {
        return user.name === undefined ? user.username : (user.name + ' ' + user.surname)
    }

    getActiveUsers() {
        return this.usersList.filter((user) => (user.state === STATE.ACTIVE || user.state === STATE.PENDING)).length;
    }

    buttonDisabled() {
        return this.maxLimitUsersPlan < this.getActiveUsers()
    }

    changeStateType(state) {
        if (state === STATE.ACTIVE) {
            return STATE.INACTIVE
        }else if (state === STATE.INACTIVE) {
            return STATE.ACTIVE
        }else if (state === STATE.PENDING) {
            return STATE.NULL
        }else if (state === STATE.CANCEL || state === STATE.NULL) {
            return STATE.PENDING
        }
    };

    currentUserCheck(user) {
        return user.username === this.currentUser.username
    }

    checkState(state) {
        return state === STATE.ACTIVE || state === STATE.PENDING
    }

    changeState(state, id, username) {
        let index = this.UsersIdsToChange.findIndex((user) => user.username === username);
        (index > -1) ?
            this.UsersIdsToChange.splice(index, 1)
            : this.UsersIdsToChange.push({'id': id, 'username': username, 'state': this.changeStateType(state)});
        this.buttonDisabled();
        this.usersList.find((user) => user.username === username).state = this.changeStateType(state);
    };

    cancel() {
        this.UsersIdsToChange.map((userIds) => {
            let newState = this.changeStateType(this.usersList.find((user) =>  user.username === userIds.username).state);
            this.usersList.find((user) => user.id === userIds.id).state = newState;
        });
        this.defer.reject();
    }

}

export default {
    template : require('./planLimitsUsers.html'),
    controller: PlanLimitsUsersController,
    controllerAs: '$ctrl'
};
